import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import React, { useState } from 'react';
import {
  DottedText,
  Tooltip,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import BasicModal from '../BasicModal';
import { NoFeatureAccess } from '../../molecules/NoFeatureAccess';

type AppCardProps = {
  title: string;
  tooltip: string;
  image: string;
  onClick: () => void;
  disabled?: boolean;
};

const AppCard: React.FC<AppCardProps> = ({
  title,
  tooltip,
  image,
  onClick,
  disabled = false,
}) => {
  const { classes } = makeStyles()({
    card: {
      height: '143px',
      width: '125px',
      border: `1px solid ${patientAccessTheme.palette.grey[300]}`,
      borderRadius: '0.5rem',
      overflow: 'hidden',
      position: 'relative',
      cursor: disabled ? 'not-allowed' : 'pointer',
    },
    tooltip: {
      backgroundColor: patientAccessTheme.palette.grey[900],
      padding: '10px',
      fontSize: '13px',
      fontFamily: 'Inter',
      fontWeight: 400,
      lineHeight: '16px',
      color: patientAccessTheme.palette.status.white,
    },
    arrow: {
      color: patientAccessTheme.palette.grey[900],
    },
    popper: {
      marginTop: '-8px',
      marginLeft: '-34px',
    },
    overlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      height: '100%',
      width: '100%',
      backgroundColor: 'rgba(255, 255, 255, 0.6)',
      zIndex: 1,
      cursor: 'not-allowed',
    },
    noAccessOverlay: {
      position: 'absolute',
      top: '0',
      left: '50%',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      padding: '10px',
      transform: 'translate( -50%)',
      backgroundColor: 'white',
      color: 'black',
      zIndex: 2,
      opacity: '0.9',
      textAlign: 'center',
    },
    overlayText: {
      fontSize: '12px',
      color: '#555',
      fontWeight: 500,
      textAlign: 'center',
    },
  })();
  const [isNoAccess, setIsNoAccess] = useState<boolean>(false);
  return (
    <Grid
      className={classes.card}
      onClick={!disabled ? onClick : undefined}
      style={{
        cursor: disabled ? 'not-allowed' : 'pointer',
      }}
    >
      <img src={image} alt={title} width="100%" />
      {disabled && (
        <Grid className={classes.noAccessOverlay}>
          <Typography
            fontSize="11px"
            textColor={patientAccessTheme.palette.text.lowemphasis}
            fontType="medium"
          >
            To know more Info!
          </Typography>
          <span
            onClick={() => {
              setIsNoAccess(true);
            }}
          >
            <DottedText text="Click Here" />
          </span>
        </Grid>
      )}
      <Typography
        fontSize="12px"
        fontType="semiBold"
        textColor={patientAccessTheme.palette.text.mediumemphasis}
        align="center"
      >
        {title}
      </Typography>
      <Tooltip
        arrow
        classes={{
          tooltip: classes.tooltip,
          arrow: classes.arrow,
          popper: classes.popper,
        }}
        title={tooltip}
        placement="bottom"
      >
        <InfoOutlinedIcon
          style={{
            width: '20px',
            height: '20px',
            fill: patientAccessTheme.palette.status.icon,
            position: 'absolute',
            top: '8px',
            left: '98px',
          }}
        />
      </Tooltip>
      {disabled && <div className={classes.overlay} />}
      <BasicModal
        open={isNoAccess}
        children={<NoFeatureAccess />}
        title={'Feature Access'}
        isSaveButton={false}
        handleClose={() => {
          setIsNoAccess(false);
        }}
      />
    </Grid>
  );
};

export default AppCard;
